import { Progress, Skeleton } from "antd";
import { displayDollar } from "utilities/tableUtility";
import { Flex } from "common/components/flex/flex";
import { MetricItem } from "../../../components/metricItem/metricItem";
import { DollarIcon } from "../../../components/icons/DollarIcon";
import { MetricIconBadge } from "../../../components/metricIconBadge/metricIconBadge";
import * as styles from "./billingProgress.module.scss";

const NAVY = "var(--navy-300)";
const GREEN = "var(--green-200)";

export const BillingProgress = ({
  totalBilling = 0,
  billingGoal = 0,
  loading = false,
}) => {
  const percent = billingGoal > 0 ? (totalBilling / billingGoal) * 100 : 0;
  const strokeColor = percent >= 100 ? GREEN : NAVY;

  const formatCenter = () => (
    <Flex direction="column" gap={6}>
      <span className={`text-secondary ${styles.billingProgress__centerLabel}`}>
        Total Billing
      </span>
      <span
        className={`font-weight-heavy ${styles.billingProgress__centerValue}`}
        style={{ color: strokeColor }}
      >
        {percent.toFixed(2)}%
      </span>
    </Flex>
  );

  if (loading) {
    return (
      <Flex direction="column" style={{ height: "100%" }}>
        <Flex align="center" justify="center" style={{ flex: 1 }}>
          <Skeleton.Avatar active shape="circle" size={220} />
        </Flex>
        <MetricItem.Skeleton />
      </Flex>
    );
  }

  return (
    <Flex direction="column" style={{ height: "100%" }}>
      <Flex align="center" justify="center" style={{ flex: 1 }}>
        <Progress
          type="circle"
          strokeLinecap="butt"
          percent={Math.min(percent, 100)}
          width={220}
          strokeWidth={16}
          strokeColor={strokeColor}
          format={formatCenter}
          className={styles.billingProgress__progress}
        />
      </Flex>
      <MetricItem
        label="Total Billing"
        icon={
          <MetricIconBadge
            icon={<DollarIcon />}
            color="var(--navy-300)"
            bgColor="var(--navy-300-10)"
          />
        }
      >
        <MetricItem.Value>
          <span>
            {displayDollar(totalBilling)}
            <span className="text-secondary">
              {" "}
              / {displayDollar(billingGoal)}
            </span>
          </span>
        </MetricItem.Value>
      </MetricItem>
    </Flex>
  );
};
